const dealSubmissionContract = {
  "slugPrefix": "deal-submission-",
  "intakeStatus": "QUEUED",
  "activityTypes": {
    "submitted": "DEAL_SUBMITTED",
    "reviewSubmitted": "DEAL_REVIEW_SUBMITTED"
  },
  "categories": [
    { "category": "BANCOS", "sector": "Bancos" },
    { "category": "TELEFONIA", "sector": "Telefonia" },
    { "category": "SUPER", "sector": "Super" },
    { "category": "RESTAURANTES", "sector": "Restaurantes" },
    { "category": "FARMACIA", "sector": "Farmacia" },
    { "category": "OTRAS", "sector": "Otras" }
  ],
  "findings": [
    { "kind": "VERIFIED", "outcome": "ACCEPTED", "reasonRequired": false },
    { "kind": "INVALID", "outcome": "REJECTED", "reasonRequired": true },
    { "kind": "UNREACHABLE", "outcome": "REJECTED", "reasonRequired": true }
  ],
  "findingPayload": {
    "versionId": { "type": "integer", "minimum": 1 },
    "reason": { "minLength": 10, "maxLength": 2000 }
  },
  "reviewScenarios": [
    { "scenario": "VERIFIED", "finding": "VERIFIED" },
    { "scenario": "REJECTED", "finding": "INVALID" },
    { "scenario": "UNREACHABLE", "finding": "UNREACHABLE" }
  ]
} as const;

export default dealSubmissionContract;
